import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-footer-slotted-block-menu.css.lit';
import { SlotController } from '../../../controllers/slot-controller';

/**
 * The GhsFooterSlottedBlockMenu component
 * @element ghs-footer-slotted-block-menu
 * @slot - default slot
 */
@customElement('ghs-footer-slotted-block-menu')
export class GhsFooterSlottedBlockMenu extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  /**
   * The menuTitle style variant to use.
   * @param menuTitle
   * @default MenuTitle
   */
  @property({
    type: String,
    attribute: 'menu-title',
    reflect: true,
  })
  menuTitle: String;

  render(): TemplateResult {
    return html`
      <div class="footer-subsection">
        <hr class="footer-subsection-hr" />
        <div class="footer-subsection-title">${this.menuTitle}</div>
        <div class="footer-subsection-slots">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
